/**
 * TIP: All paths rule is kebab-case
 */

const paths = {
  /* MAIN PAGES */
  profile: '/app/profile',
  analytics: '/app/analytics',
  lock: '/app/lock',
  accessDenied: '/app/access-denied',
  roleAccess: '/app/access-denied',
  licenseAccess: '/app/lock',

  /* NDIS PAGES */
  participants: '/ndis/participants',
  serviceBookings: '/ndis/service-bookings',
  serviceDelivery: '/ndis/service-delivery',
  createServiceBooking: '/ndis/create-service-booking',
  importParticipantByExcel: '/ndis/import-participant',
  importParticipantResult: '/ndis/import-participant-result',
  importRemittanceByExcel: '/ndis/import-remittance',
  importRemittanceResult: '/ndis/import-remittance-result',
  importROCByExcel: '/ndis/import-roc',
  importROCResult: '/ndis/import-roc-result',
  importShiftAsyncResult: '/ndis/import-shift-async-result',
  readyToInvoice: '/ndis/ready-to-invoice',
  issuedInvoices: '/ndis/issued-invoices',
  invoiceDetails: '/ndis/invoice-details',
  invoicesInError: '/ndis/invoices-in-error',
  invoiceBatchHistory: '/ndis/invoice-batch-history',
  participant360View: '/ndis/participant-360-view',
  readyToClaim: '/ndis/ready-to-claim',
  recoveryClaim: '/ndis/recovery-claim',
  claimsInError: '/ndis/claims-in-error',
  claimBatchHistory: '/ndis/claim-batch-history',
  claimBatchDetail: '/ndis/claim-batch-detail',
  successfulClaims: '/ndis/successful-claims',
  successfulClaimsNewGrid: '/ndis/successful-claims-new-grid',
  paymentCancellation: '/ndis/payment-cancellation',
  rosterOfCare: '/ndis/roster-of-care',
  remittance: '/ndis/remittance',
  budget: '/ndis/budget',
  transactions: '/ndis/transactions',
  issuedInvoicesV2: '/ndis/issued-invoices-v2',
  invoiceBatchHistoryV2: '/ndis/invoice-batch-history-v2',

  /* COMMON */
  settings: '/settings',
  categoryX: '/app/category-x',
  categoryY: '/app/category-y',
  registrations: '/app/registrations',
  ndisNotifications: '/app/ndis-notifications',
  financialContact: '/app/contacts',
  products: '/app/products',
  labels: '/app/labels',
  legalEntityManagement: '/app/legal-entity-management',
  personManagement: '/app/ar/person-management',
  personDetails: '/app/ar/person-management/:personId',
  invoices: '/app/ar/invoices',
  invoiceBatches: '/app/ar/invoice-batches',
  invoiceDetailsV2: '/app/ar/invoices/:invoiceId',
  paymentsV2: '/app/ar/payments',
  payerStatements: '/app/ar/payer-statements',
  arSettlement: '/app/ar/settlement',
  integration: '/app/integration',

  /* SUPPORT AT HOME */
  supportAtHomeCareRecipient360: '/support-at-home/care-recipient-360',
  supportAtHomeCareRecipients: '/support-at-home/care-recipients',
  supportAtHomeCareRecipientImportHistory: '/support-at-home/care-recipient-import-history',
  supportAtHomeTransactions: '/support-at-home/transactions',
  supportAtHomeReadyToClaim: '/support-at-home/ready-to-claim',
  supportAtHomeClaims: '/support-at-home/claims',
  supportAtHomeClaimHistory: '/support-at-home/claim-history',
  supportAtHomeReadyToInvoice: '/support-at-home/ready-to-invoice',
  supportAtHomeMonthlyStatements: '/support-at-home/statements/monthly',
  supportAtHomeCareRecipientStatements: '/support-at-home/statements/care-recipient',
  supportAtHomeStatementSettings: '/support-at-home/statements/settings',
  supportAtHomeProviders: '/support-at-home/providers',
  supportAtHomeTransactionImportHistory: '/support-at-home/transaction-import-history',
  supportAtHomeImportTransactions: '/support-at-home/import-transactions',
  supportAtHomePricing: '/support-at-home/pricing',
  supportAtHomeBudget: '/support-at-home/budget',
  supportAtHomeBudgetDetails: '/support-at-home/budget/:id',

  /* AUTH */
  welcome: '/welcome',
  login: '/signin',
  register: '/signup',
  termsAndConditions: '/terms-and-conditions',
  forgetPassword: '/forgot-password',
  selectOrg: '/select-organisation',
  callback: '/signin/callback',
};

export default paths;
